var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.DiseaseModal, {
    attrs: {
      value: _setup.isDialogOpened,
      "is-back": "",
      title: _setup.t("Что лечит врач", _setup.options),
      placeholder: _setup.t("Заболевание", _setup.options),
      "page-type": _setup.pageType,
      "town-id":
        _setup.filtersStore.filters.visitLocation === "online"
          ? undefined
          : _setup.commonStore.town.id,
      "speciality-id": _setup.filtersStore.filters.speciality.id,
      "selected-disease": _setup.filtersStore.unsavedFilters.disease,
    },
    on: {
      "disease:selected": _setup.onClickDisease,
      "disease:reset": _setup.onReset,
      input: _setup.handleCloseModal,
    },
    scopedSlots: _vm._u([
      {
        key: "footer",
        fn: function () {
          return [
            _c(_setup.BtnShowDoctors, {
              staticClass: "pa-2 elevation-8",
              attrs: { active: _setup.isDialogOpened },
              on: {
                "click:submit": _setup.applySelectedDisease,
                "click:close": _setup.closeDialog,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }